import { axiosInstance as axios, handleAxiosErrors } from '../../_utils';
import config from '../../store/_config';
import { convertUserDetailedInformationToAReadableFormat } from '../../selectors/converterSelector';
import {
    toggleLoading,
    setUserInfo,
    axiosUpdateAccountHolderInformation,
} from '../userActions';

export const requestReferralCoupons = () => {
    return (dispatch) => {
        dispatch(toggleLoading('referralCouponList', true));
        return axiosRequestReferralCoupons()
            .then((response) => {
                const userInfo = convertUserDetailedInformationToAReadableFormat(
                    response.data.data.readOneMember
                );
                dispatch(setUserInfo(userInfo));

                dispatch(toggleLoading('referralCouponList', false));
            })
            .catch((error) => {
                handleAxiosErrors(error);
                dispatch(toggleLoading('referralCouponList', false));
            });
    };
};

export const createReferralCoupon = (formData, callback) => {
    return (dispatch) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        const { showMoreFields } = formData;

        return axiosCreateReferralCoupon(formData)
            .then((response) => {
                dispatch(requestReferralCoupons());

                // which means it's not the first time to fill in the referral coupon
                if (!showMoreFields) {
                    if (successCallback) successCallback(response);
                    if (alwaysCallback) alwaysCallback(response);
                    return;
                }

                return axiosUpdateAccountHolderInformation(formData)
                    .then((response) => {
                        const userInfo = convertUserDetailedInformationToAReadableFormat(
                            response.data.data.updateMemberInfo
                        );
                        dispatch(setUserInfo(userInfo));

                        // Callbacks
                        if (successCallback) successCallback(response);
                        if (alwaysCallback) alwaysCallback(response);
                    })
                    .catch((response) => {
                        handleAxiosErrors(response);

                        // Callbacks
                        if (errorCallback) errorCallback(response);
                        if (alwaysCallback) alwaysCallback(response);
                    });
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};

export const axiosRequestReferralCoupons = (memberID = null) => {
    let { url, query } = config.user.referralCoupons;

    if (memberID != null) {
        query = query.replace(
            'readOneMember',
            `readOneMember(ID: ${memberID})`
        );
    }

    return axios.get(url, {
        withCredentials: true,
        params: {
            query: query,
        },
    });
};

export const axiosCreateReferralCoupon = (formData) => {
    let { url, query } = config.user.createReferralCoupon;

    query = query.replace(/{params}/, `Code: "${formData.ReferralCoupon}"`);

    return axios.post(
        url,
        {
            query,
        },
        {
            withCredentials: true,
        }
    );
};
